import {type FilterProvider, FilterProviderType} from '@github-ui/filter-core'
import {MoonIcon} from '@primer/octicons-react'

export function createParserProvider(
  key: string,
  filterTypes: FilterProvider['options']['filterTypes'],
): FilterProvider {
  return {
    key,
    icon: MoonIcon,
    priority: 0,
    getSuggestions: () => null,
    type: FilterProviderType.Text,
    validateFilterBlockValues: (_filterQuery, _block, values) => values,
    getValueRowProps: () => ({text: ''}),
    options: {
      priority: 0,
      filterTypes,
      support: {},
    },
  }
}
